import * as React from 'react';

function SvgComponent(props) {
    const size = props?.size || 18;

    return (
        <svg
            width={size}
            height={(19 / 18) * size}
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16.835 5.825v1.44a2.476 2.476 0 00-1.513 2.274c0 1.019.623 1.894 1.513 2.274v1.44c0 1.368-.995 2.283-2.508 2.477-4.16.532-6.487.536-10.655 0-1.47-.19-2.507-1.11-2.507-2.477v-1.44a2.476 2.476 0 001.513-2.274 2.476 2.476 0 00-1.513-2.274v-1.44c0-1.368 1.047-2.232 2.507-2.477 4.119-.69 6.478-.586 10.655 0 1.382.194 2.508 1.109 2.508 2.477zM11.41 9.198v.603M11.41 5.583v.602M11.41 12.815v.602"
                stroke="currentColor"
                strokeWidth={1.25}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
